import _ from 'lodash';

class ImageDetailController {
  constructor(Image, $uibModal) {
    "ngInject";

    let vm = this;
    vm.$onInit = function () {
      if (vm.resolve && vm.resolve.imageSource) {
        vm.imageSource = vm.resolve.imageSource;
      }
    }

    vm.deleteImage = function () {
      $uibModal.open({
        component: 'confirmDialog',
        windowClass: 'modal-mini modal-primary',
        resolve: {
          message: () => "Confermi di voler cancellare l'immagine selezionata?"
        }
      }).result.then(() => {
        Image.deleteImage(vm.resolve.imageId)
        .then(function () {
          if(_.isFunction(vm.resolve.callback)){
            vm.resolve.callback();
            vm.close();
          }
        })

      })
    }
  }
}

export default ImageDetailController;



// WEBPACK FOOTER //
// ./client/app/common/imageDetail/imageDetail.controller.js